/**
 * @module 1-liners/isFunction
 *
 * @description
 *
 * Same as `typeof value === 'function'`.
 *
 * @example
 *
 * 	const isFunction = require('1-liners/isFunction');
 *
 * 	isFunction(function() {});        // => true
 * 	isFunction(function named() {});  // => true
 *
 * 	isFunction('any other value');    // => false
 *
 */
'use strict';

exports.__esModule = true;

exports['default'] = function (value) {
  return typeof value === 'function';
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/1-liners/isFunction.js
// module id = 1359
// module chunks = 0